import { useAuthStore } from '@/store/auth.store';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import {useHttp} from "@/composable/service/useHttp";
import userHttp from "@/services/http/user.http";


export function useAuthLogout() {
  const http = useHttp(userHttp.logoutMyself);
  const authStore = useAuthStore();
  const router = useRouter();
  const loading = ref<boolean>(true);
  const error = ref<Error | null>(null);
  const request = () => new Promise(async () => {
    const token = authStore.token;
    const res = await http.request({ userToken: token});
    authStore.removeUser();
    authStore.removeToken();
    router.push({name: 'LogoutView'}).then(() => loading.value = false);
  }).catch((err: unknown) => {
    error.value = err as Error;
    loading.value = false;
  });
  return {
    loading,
    error,
    request,
  };
}
